<ng-container *ngIf="searchRequest">
  <ng-container *ngFor="let type of searchRequest.primaryType.facets">
    <span class="badge badge-pill badge-custom mr-2" *ngIf="type.checked">{{ type.value }} <i class="icon-close" (click)="resetMachineType(type)"></i></span>
  </ng-container>
  <ng-container *ngFor="let make of searchRequest.make.facets">
    <span class="badge badge-pill badge-custom mr-2" *ngIf="make.checked"
      >{{ make.value }} <i class="icon-close" (click)="unCheckCountValueFacet(make)"></i
    ></span>
  </ng-container>

  <ng-container *ngFor="let model of searchRequest.model.facets">
    <span class="badge badge-pill badge-custom mr-2" *ngIf="model.checked"
      >{{ model.value }} <i class="icon-close" (click)="unCheckCountValueFacet(model)"></i
    ></span>
  </ng-container>

  <span class="badge badge-pill badge-custom mr-2" *ngIf="searchRequest.hours.selected"
    >{{ searchRequest.hours.slider.minValue }} - {{ searchRequest.hours.slider.maxValue }} hrs
    <i class="icon-close" (click)="resetRange(searchRequest.hours)"></i
  ></span>

  <ng-container *ngFor="let weight of searchRequest.weight.facets">
    <span class="badge badge-pill badge-custom mr-2" *ngIf="weight.checked"
      >{{ weight.label || (weight.value | number) + " lbs" }} <i class="icon-close" (click)="unCheckCountValueFacet(weight)"></i
    ></span>
  </ng-container>

  <span class="badge badge-pill badge-custom mr-2" *ngIf="searchRequest.enginePower.selected"
    >{{ searchRequest.enginePower.slider.minValue }} - {{ searchRequest.enginePower.slider.maxValue }} hp
    <i class="icon-close" (click)="resetRange(searchRequest.enginePower)"></i
  ></span>

  <ng-container *ngFor="let catalog of searchRequest.attachment.catalogs.facets">
    <span class="badge badge-pill badge-custom mr-2" *ngIf="catalog.checked"
      >{{ catalog.label }} <i class="icon-close" (click)="unCheckCountValueFacet(catalog)"></i
    ></span>
  </ng-container>

  <ng-container *ngFor="let spec of searchRequest.attachment.specs.facets">
    <span class="badge badge-pill badge-custom mr-2" *ngIf="spec.checked">
      <span class="text-white" [innerHtml]="spec.label"></span> <i class="icon-close" (click)="unCheckCountValueFacet(spec)"></i
    ></span>
  </ng-container>

  <span class="badge badge-pill badge-custom mr-2" *ngIf="searchRequest.year.selected"
    >{{ searchRequest.year.slider.minValue }} - {{ searchRequest.year.slider.maxValue }}<i class="icon-close" (click)="resetRange(searchRequest.year)"></i
  ></span>
</ng-container>
